import request from '@/utils/request.js'

export function strategyList() {
  return request({
    url: '/strategy/list',
    method: 'get',
  })
}
